import { TIME_ZONE_ALIASES } from '@/creditflowresearch/application/User/UserTimeZone/constants/timeZoneAliases';

/**
 * The browser's IANA time zone, translated to the name the time zone dictionary uses.
 * See TIME_ZONE_ALIASES for why the translation is needed.
 */
export const getBrowserTimeZone = (): string | null => {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

    if (!timeZone) {
      return null;
    }

    return TIME_ZONE_ALIASES[timeZone] ?? timeZone;
  } catch {
    return null;
  }
};
